var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('limitless-page-header',{attrs:{"title":'Tidrapportering'}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"card card-body"},[_c('time-care-form',{attrs:{"id":_vm.user.id}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }